import { useState, useEffect } from 'react';
import { AdminQuery } from '../types';
import { adminQueriesService } from '../services/admin-queries.service';

export const useAdminQueries = () => {
  const [queries, setQueries] = useState<AdminQuery[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [analytics, setAnalytics] = useState<any>(null);

  const loadQueries = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      const [queriesData, analyticsData] = await Promise.all([
        adminQueriesService.getAllQueries(),
        adminQueriesService.getQueryAnalytics(),
      ]);

      setQueries(queriesData);
      setAnalytics(analyticsData);
    } catch (err: any) {
      setError(err.message || 'Failed to load queries');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadQueries();
  }, []);

  return {
    queries,
    analytics,
    isLoading,
    error,
    refetch: loadQueries,
  };
};

